class OptionsAccordion extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    // Close automatically if dynamically rendered in open state
    if (this.dataset.open === 'true') {
      setTimeout(() => {
        this.dataset.open = false
      }, 0)
    }
  }

  setupListeners () {
    this.handleTrigger = this.handleTrigger.bind(this)

    this.listeners.add(this, 'click', this.handleTrigger)
    this.listeners.add(this, 'click', this.handleClose)
  }

  handleTrigger (event) {
    const triggerEl = event.target.closest(this.els?.trigger?.selector)
    if (!triggerEl) return

    const itemEl = event.target.closest(this.els?.item?.selector)
    if (!itemEl) return

    this.els?.item?.elements.forEach((tempEl) => {
      if (tempEl !== itemEl) {
        tempEl.setAttribute('aria-expanded', 'false')
      }
    })

    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    itemEl.setAttribute('aria-expanded', !currentState)
  }

  handleClose (event) {
    const closeEl = event.target.closest(this.els?.close?.selector)
    if (!closeEl) return

    const itemEl = event.target.closest(this.els?.item?.selector)
    if (!itemEl) return

    this.els?.item?.elements.forEach((tempEl) => {
      if (tempEl !== itemEl) {
        tempEl.setAttribute('aria-expanded', 'false')
      }
    })

    const currentState = itemEl.getAttribute('aria-expanded') === 'true'
    itemEl.setAttribute('aria-expanded', !currentState)
  }
}

if (!customElements.get('options-accordion')) {
  customElements.define('options-accordion', OptionsAccordion)
}
